<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <span>
            <span>ثبت پرداخت</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>


    <div mat-dialog-content class="matDialogContent" style="overflow-y: hidden;">
        <div style="text-align: right;">
            <button class="button_default new1" (click)='new()'>جديد</button>
        </div>
        <div class="content-body2 control-content-body" [ngClass]="{content_body_en:lang==2}"
            style='overflow-x:auto;direction:rtl;' (window:resize)="change_resize()">
            <mat-table [dataSource]="dataSource" style='min-width:100%'
                class='table-scroll mat_table_fa_without_scroll pe1'
                [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
                [ngStyle]="lang == 2 && {direction:'ltr'}">

                <ng-container matColumnDef="row">
                    <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                        <span *ngIf="lang == 1">ردیف</span>
                        <span *ngIf="lang == 2">#</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>{{ i + page_number_first }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="title">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="lang == 1">عنوان تراکنش</span>
                        <span *ngIf="lang == 2">Title</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
                        x.sale_payment_title }}</mat-cell>
                </ng-container>


                <ng-container matColumnDef="payment">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="lang == 1">مبلغ پرداختی</span>
                        <span *ngIf="lang == 2">---</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
                        x.sale_payment_price | number }}</mat-cell>
                </ng-container>


                <ng-container matColumnDef="date3">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="lang == 1">تاریخ تراکنش</span>
                        <span *ngIf="lang == 2">----</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
                        x.sale_payment_date3 }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="creator">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="lang == 1">ثبت کننده</span>
                        <span *ngIf="lang == 2">---</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
                        x.creator }}
                    </mat-cell>
                </ng-container>




                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="lang == 1"> شناسه </span>
                        <span *ngIf="lang == 2">Id</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" (click)='open_detaile(i,2,x.sale_payment_id)'>{{
                        x.sale_payment_id }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="operation">
                    <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                        <span *ngIf="lang == 1"> عملیات </span>
                        <span *ngIf="lang == 2">Operation</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>
                        <span (click)='open_detaile(i,2,x.sale_payment_id)'><i class="fas fa-desktop icon"></i></span>
                        <span (click)="check_access(3,'',x.sale_payment_id,'',1)"><i class="far fa-trash-alt icon"
                                style='margin:0px 4px;'></i></span>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
                <mat-row *matRowDef="let row;columns:displayedColumns;let i = index"
                    (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                    (dblclick)="open_detaile(i,2,row.sale_payment_id)"
                    [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,'mat_table_hover': row === mat_table_hoverRow}"
                    class="cursor"></mat-row>

            </mat-table>

            <div class="row" class="preview1" [hidden]="count_total > 0">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div>
                        <img src="../../../../assets/images/preview.png">
                    </div>
                    <div class="preview2" *ngIf="lang == 1">هیچ رکوردی برای نمایش وجود ندارد</div>
                    <div class="preview2" *ngIf="lang == 2">There are no records to display</div>
                </div>
            </div>

        </div>
    </div>
    <!-- ********************************************************************************************************************** -->
    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
    </div>
</div>